<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>

<template>
  <div>
    {{$t('news.template.party.applicationReceivedConsolidated.p1')}}
    {{news.textParams[0]}}
    {{$t('news.template.party.applicationReceivedConsolidated.p2')}}
    <a class="consolidated-news"
       href="#"
    @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
  >{{news.textParams[1]}}</a>
    {{$t('news.template.party.applicationReceivedConsolidated.p3')}}
  </div>
</template>
